/* Hectic Decals — stabilize Froonze wishlist on product-card hover.
   Product cards swap media layers on hover. FRCP sometimes injects its wrapper inside
   that media subtree, so the whole control vanishes with the outgoing slide.
   Move the existing FRCP wrapper to the product-card root; listeners stay attached. */
(function(){
  'use strict';

  var scheduled=false;

  function mountCard(card){
    if(!card || !card.querySelectorAll) return;
    var wrappers=card.querySelectorAll('.frcp-wishlist-grid-btn-wrapper');
    wrappers.forEach(function(wrapper){
      if(wrapper.parentElement!==card){
        card.appendChild(wrapper);
      }
      wrapper.classList.add('hd-wishlist-mounted');
    });
  }

  function scan(root){
    var base=root&&root.querySelectorAll?root:document;
    if(base.matches&&base.matches('.frcp-wishlist-grid-item')) mountCard(base);
    base.querySelectorAll('.frcp-wishlist-grid-item').forEach(mountCard);
  }

  function scheduleScan(){
    if(scheduled)return;
    scheduled=true;
    requestAnimationFrame(function(){
      scheduled=false;
      scan(document);
    });
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){scan(document)});
  }else{
    scan(document);
  }

  new MutationObserver(scheduleScan).observe(document.documentElement,{
    childList:true,
    subtree:true
  });

  document.addEventListener('pointerover',function(e){
    var card=e.target&&e.target.closest&&e.target.closest('.frcp-wishlist-grid-item');
    if(card) mountCard(card);
  },true);

  document.addEventListener('focusin',function(e){
    var card=e.target&&e.target.closest&&e.target.closest('.frcp-wishlist-grid-item');
    if(card) mountCard(card);
  },true);
})();